import { render, staticRenderFns } from "./InputDescription.vue?vue&type=template&id=7e013fda&"
import script from "./InputDescription.vue?vue&type=script&lang=js&"
export * from "./InputDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports